var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'de-logo': true, 'de-logo--badge': _vm.badge, 'de-logo--large-badge': _vm.large && _vm.badge }},[_c('img',{class:{
        'de-logo__img--icon': _vm.badge,
        'de-logo__img--wordmark': !_vm.badge,
    },attrs:{"src":_vm.imgSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }